export default "__VITE_ASSET__CaMQcQU0__"